import React, {Component} from "react";
import Group from "../../../Components/Group";
import './index.css';
import Hospital from "../../../Server/Hospital";
import Grid, {GridButton, GridControls, gridDateTime} from "../../../Components/Grid";
import Resource from "../../../Resource";
import ModalHospitalOutgoingCancel from "../../Modal/ModalHospitalOutgoingCancel";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import ModalPrint from "../../Modal/ModalPrint";
import {printerTemplate} from "../../../Printer";
import moment from "jalali-moment";
import {connect} from "react-redux";
import BarcodeReader from 'react-barcode-reader';
import Perms from '../../../Perms';

class PageHospitalOutgoing extends Component {
    constructor(props) {
        super(props);

        if (!Perms().BLOOD_BANK_OUTGOING.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: 'اطلاعات بیمار',
                    children: [{
                        field: 'patientFileCode',
                        headerName: 'شماره پرونده',
                        headerTooltip: 'شماره پرونده',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        // aggFunc: row => row.values[0],
                        filter: 'agTextColumnFilter',
                    }, {
                        field: 'patientFullName',
                        headerName: 'نام بیمار',
                        headerTooltip: 'نام بیمار',
                        // aggFunc: row => row.values[0]
                    }, {
                        field: 'patientBloodGroupStr',
                        headerName: 'BGRh بیمار',
                        headerTooltip: 'BGRh بیمار',
                        cellClass: row => {
                            if (row.data?.patientBloodGroupId && row.data?.patientBloodGroupId === row.data?.productBloodGroupId) {
                                return 'green';
                            } else if (row.data?.patientBloodGroupId !== row.data?.productBloodGroupId) {
                                return 'red';
                            }
                        },
                        cellRenderer: row => row.data.patientBloodGroupStr || '-'
                    }]
                }, {
                    headerName: 'اطلاعات فرآورده',
                    children: [{
                        field: 'productNumber',
                        headerName: 'شماره فرآورده',
                        headerTooltip: 'شماره فرآورده',
                        filter: 'agTextColumnFilter'
                    }, {
                        field: 'productTypeStr',
                        headerName: 'نوع فرآورده',
                        headerTooltip: 'نوع فرآورده'
                    }, {
                        field: 'productBloodGroupStr',
                        headerName: 'BGRh فرآورده',
                        headerTooltip: 'BGRh فرآورده',
                        cellClass: row => {
                            if (row.data?.patientBloodGroupId && row.data?.patientBloodGroupId === row.data?.productBloodGroupId) {
                                return 'green';
                            } else if (row.data?.patientBloodGroupId !== row.data?.productBloodGroupId) {
                                return 'red';
                            }
                        }
                    }]
                }, {
                    headerName: 'اطلاعات خروج فرآورده',
                    children: [{
                        field: 'sectionStr',
                        headerName: 'ارسال شده به بخش',
                        headerTooltip: 'ارسال شده به بخش'
                    }, {
                        field: 'crossMatcherFullName',
                        headerName: 'آزمایش کننده',
                        headerTooltip: 'آزمایش کننده',
                    }, {
                        field: 'senderFullName',
                        headerName: 'تحویل دهنده',
                        headerTooltip: 'تحویل دهنده',
                    }, {
                        field: 'receiverFullName',
                        headerName: 'تحویل گیرنده',
                        headerTooltip: 'تحویل گیرنده',
                    }, {
                        field: 'createDateTime',
                        headerName: 'زمان ارسال',
                        headerTooltip: 'زمان ارسال',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    hide: !(Perms().BLOOD_BANK_OUTGOING.CANCEL || Perms().BLOOD_BANK_OUTGOING.RETRIEVE_TO_BLOOD_BANK),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    control: row => {
                        const perm = Perms().BLOOD_BANK_OUTGOING.CANCEL || Perms().BLOOD_BANK_OUTGOING.RETRIEVE_TO_BLOOD_BANK;
                        return <GridControls>
                            <GridButton type={'button'} theme={'print'} icon={Resource.IMAGE.PACK.PRINTER.WHITE} title={'چاپ'} onClick={this.print.bind(this, row.data)}/>
                            {perm && <GridButton type={"button"} theme={'edit'} icon={Resource.IMAGE.PACK.REPLY.BLACK} title={'لغو / عودت'} onClick={this.del.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'لغو ارسال / عودت فرآورده به بانک خون',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.REPLY.BLACK}" alt="">`,
                            action: this.del.bind(this, params.node.data),
                            disabled: !Perms().BLOOD_BANK_OUTGOING.CANCEL && !Perms().BLOOD_BANK_OUTGOING.RETRIEVE_TO_BLOOD_BANK
                        }, {
                            name: 'چاپ',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.PRINTER}" alt="">`,
                            action: this.print.bind(this, params.node.data)
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                                <p className={'help-back-red'}>نشان دهنده مغایرت گروه خونی بیمار با فرآورده ارسال شده می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'print'} title={'چاپ'}/> درصورت نیاز به چاپ مجدد برچسب آماده سازی و فرم‌های نظارت بر تزریق می توانید از این طریق اقدام کنید..</p>
                                <p><GridButton theme={'edit'} title={'لغو / عودت'} icon={Resource.IMAGE.PACK.REPLY.BLACK}/> درصورت نیاز به لغو و یا عودت ارسال فرآورده می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            modalHospitalOutgoingCancel: React.createRef(),
            print: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <BarcodeReader
                onScan={this.barcodeScanHandler.bind(this)}/>
            <Group className={'PageHospitalOutgoing-group mar-10'} title={'فرآورده‌های خروجی'} description={'لیست فرآورده‌های خارج شده از این قسمت قابل مشاهده می باشد.'}>
                <Grid refer={this.ref.grid } id={'hemoOutgoing'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <ModalHospitalOutgoingCancel refer={this.ref.modalHospitalOutgoingCancel} onSuccess={this.updateGrid.bind(this)}/>
            <ModalPrint refer={this.ref.print}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        Hospital.outgoingList()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    barcodeScanHandler(code) {
        //barcodes
        const barcode = Tool.checkBarcode(code);
        if (barcode.type === 'PRODUCT_NUMBER') {
            this.state.gridContext.api.setFilterModel({
                productNumber: {
                    type: 'contains',
                    filter: barcode.data,
                }
            });
        }
    }

    del(row) {
        this.ref.modalHospitalOutgoingCancel.current.open(row);
    }

    print(row, props = {loading: _ => null}) {
        const printModal = this.ref.print.current;

        props.loading();
        Hospital.getDeliveryData({outcomingId: row?.outcomingId})
            .then(data => {
                props.loading(false);

                const prints = [];

                prints.push({
                    id: 'outgoingLabel',
                    title: 'لیبل خروج فرآورده',
                    count: 1,
                    template: printerTemplate.OUTGOING_LABEL,
                    parameters: {
                        PFullName: row?.patientFullName,
                        PFileCodeStr: row?.patientFileCode,
                        PBloodGroupStr: row?.patientBloodGroupStr,
                        PNationalCode: row?.patientNationalCode,
                        SectionStr: row?.sectionStr,
                        SendDateTime: data?.sendDateTime ? moment(data?.sendDateTime).format('jYYYY/jMM/jDD HH:mm') : '-',
                        StatusStr: data?.sazghar,
                        SamplerFullName: row?.crossMatcherFullName
                    }
                });

                if (data?.bloodForms) {
                    prints.push({
                        id: 'outgoingFormEnzymeType1',
                        title: 'فرم نظارت بر تزریق‌ خون',
                        count: 1,
                        template: printerTemplate.OUTGOING_FORM_ENZYME_TYPE_1,
                        parameters: data?.bloodForms?.map(item => {
                            return {
                                ProductTypeStr: item?.productTypeStr,
                                ProductExpireDate: item?.productExpireDate ? moment(item.productExpireDate).format('jYYYY/jMM/jDD') : '',
                                ProductNumber: item?.productNumber,
                                ProductBloodGroupStr: item?.productBloodGroupStr,
                                SectionStr: data?.sectionStr,
                                PatientBloodGroupStr: data?.patientBloodGroupStr,
                                PatientFullName: data?.patientFullName,
                                PatientFileCodeStr: data?.patientFileCodeStr,
                                PatientFather: data?.patientFather,
                                PatientNationalCode: data?.patientNationalCode,
                                PatientBirthDate: data?.patientBirthDate,
                                CrossMatcherFullName: data?.crossMatcherFullName,
                                ReceiverFullName: data?.receiverFullName,
                                SenderFullName: data?.senderFullName,
                                SendDateTime: moment(data?.sendDateTime).format('jYYYY/jMM/jDD HH:mm'),
                                HospitalStr: data?.hospitalStr,
                                ProvinceStr: data?.provinceStr,
                                CityStr: data?.cityStr,
                                Sazghar: data?.sazghar,
                                GenderId: data?.genderId,
                                CrossMachDateTime: data?.crossMatchDateTime ? moment(data?.crossMatchDateTime).format('jYYYY/jMM/jDD HH:mm') : '-',
                                NeedDateTime: data?.needDateTime ? moment(data?.needDateTime).format('jYYYY/jMM/jDD HH:mm') : '-'
                            };
                        })
                    });
                }

                if (data?.plateletForms) {
                    prints.push({
                        id: 'outgoingFormOtherEnzymeType',
                        title: 'فرم نظارت بر تزریق پلاکت',
                        count: 1,
                        template: printerTemplate.OUTGOING_FORM_OTHER_ENZYME_TYPE,
                        parameters: data?.plateletForms.map(item => {
                            return {
                                HospitalStr: data?.hospitalStr,
                                ProvinceStr: data?.provinceStr,
                                CityStr: data?.cityStr,
                                SectionStr: data?.sectionStr,
                                PatientFullName: data?.patientFullName,
                                PatientNationalCode: data?.patientNationalCode,
                                PatientFileCodeStr: data?.patientFileCodeStr,
                                PatientFatherName: data?.patientFather,
                                PatientBirthDate: data?.patientBirthDate,
                                PatientBloodGroupStr: data?.patientBloodGroupStr,
                                ProductsCount: item?.productsCountStr,
                                GenderId: data?.genderId,
                                SendDateTime: data?.sendDateTime ? moment(data?.sendDateTime).format('jYYYY/jMM/jDD HH:mm') : '-',
                                SenderFullName: data?.senderFullName,
                                ReceiverFullName: data?.receiverFullName
                            };
                        }),
                        datatables: data?.plateletForms.map(item => {
                            return {
                                DT: item?.productsInfo?.map(item => {
                                    return {
                                        ProductBloodGroupStr: item?.productBloodGroupStr,
                                        ProductExpireDate: item?.productExpireDate ? moment(item?.productExpireDate).format('jYYYY/jMM/jDD') : '',
                                        ProductNumber: item?.productNumber,
                                        ProductTypeStr: item?.productTypeStr
                                    };
                                })
                            };
                        })
                    });
                }

                if (prints.length)
                    printModal.open({
                        title: 'چاپ برچسب/فرم فرآورده',
                        prints
                    });
            })
            .catch(message => {
                props.loading(false);
                new Notif({message, theme: 'error'}).show();
            });
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(PageHospitalOutgoing);